import { PrintButtonVariant } from "./PrintSpecimenButton";

type PrintSpecimenButtonViewProps = {
  performPrintAction?: () => void;
  variant: PrintButtonVariant;
  children?: React.ReactNode;
};

const fnNoPrintActionProvided = () =>
  console.error("Print action not provided");

const PrintSpecimenButtonView = ({
  performPrintAction = fnNoPrintActionProvided,
  variant,
  children,
}: PrintSpecimenButtonViewProps) => {
  return (
    <button
      className={`Button PrintSpecimenButton PrintSpecimenButton--${variant}`}
      onClick={() => {
        performPrintAction && performPrintAction();
      }}
    >
      {children}
    </button>
  );
};

export default PrintSpecimenButtonView;
